'use client'

// src/constants/age.ts
var MIN_AGE_ALLOWED = 13;

export {
  MIN_AGE_ALLOWED
};
//# sourceMappingURL=chunk-F4OYSSS5.mjs.map